//
//
//
//
//
//
//
//
//
//
//
//
//
//
import authService from "../services/AuthService";
import FetchError from "../services/api/FetchError";
import LogoutHeader from "../layouts/components/LogoutHeader.vue";
export default {
  components: {
    LogoutHeader: LogoutHeader
  },
  name: "PreLoader",
  data: function data() {
    return {
      FetchError: FetchError
    };
  },
  computed: {
    error: function error() {
      var _this$$store$state$pr = this.$store.state.profile,
          myProfile = _this$$store$state$pr.myProfile,
          managedProviders = _this$$store$state$pr.managedProviders;
      return myProfile.error || managedProviders.error;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      if (authService.id) {
        this.$store.dispatch("profile/FETCH_MY_PROFILE");
        this.$store.dispatch("profile/FETCH_MANAGED_PROVIDERS");
      } else {
        this.$store.dispatch("profile/FETCH_MY_PROFILE", function () {
          _this.$store.dispatch("profile/FETCH_MANAGED_PROVIDERS");
        });
      }
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
};